<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 4C15.4477 4 15 4.44772 15 5V15C15 15.5523 15.4477 16 16 16C16.5523 16 17 15.5523 17 15V5C17 4.44772 16.5523 4 16 4ZM11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V7ZM8 8C7.44772 8 7 8.44772 7 9V15C7 15.5523 7.44772 16 8 16C8.55228 16 9 15.5523 9 15V9C9 8.44772 8.55228 8 8 8ZM4 10C3.44772 10 3 10.4477 3 11V15C3 15.5523 3.44772 16 4 16C4.55228 16 5 15.5523 5 15V11C5 10.4477 4.55228 10 4 10Z"
  />
</svg>
